import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfirmareDocumenteService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getDocumenteConfirmateDTUrl = this.basePath + environment.interop.dgitl.confirmareDocumente.getDocumenteCofirmareDT;

    public fileDownloadUrl = this.basePath + environment.interop.dgitl.confirmareDocumente.fileDownload;

    constructor(private http: HttpClient) { }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
